// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasKpi_RecorrenciaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/vendas_kpi/recorrencia.
 *
 * `total_clientes` = distinct clientes with a non-cancelled order in the period.
 * `clientes_recorrentes` = subset of total_clientes who already had an earlier
 *   non-cancelled order.
 * `taxa` = clientes_recorrentes / total_clientes as int * 100 (3333 = 33,33%);
 *   0 when there are no clientes.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface VendasKpi_RecorrenciaResponseDados {
total_clientes: number
clientes_recorrentes: number
taxa: number
}

export type VendasKpi_RecorrenciaResponse = ApiResponse<VendasKpi_RecorrenciaResponseDados>;

registerResponseContract('VendasKpi_RecorrenciaResponse', {
  total_clientes:       { type: 'number',  required: true },
  clientes_recorrentes: { type: 'number',  required: true },
  taxa:                 { type: 'number',  required: true },
})
